export default __webpack_public_path__ + "static/1206-135bcc8737805da70fc8f42604a7a9c9.gif";